export var insectData = {
  "create_time": "2020-04-13 13:56:37",
  "csq": 6,
  "data": [{
      "address": 1,
      "data": {
        number: 1
      },
      "data_class": "temperature"
    },
    {
      "address": 1,
      "data": {
        number: 1
      },
      "data_class": "humidity"
    },
    {
      "address": 2,
      "data": {
        number: 10
      },
      "data_class": "temperature"
    }
  ],
  "description": "\u6837\u4f8b",
  "dnds": 0,
  "dtype": 3,
  "dver": "2.2.14Gai",
  "gs": 0,
  "hs": 0,
  "lat": "34.81005478",
  "lng": "113.65996552001185",
  "lps": 0,
  "mac": "806263647000119",
  "room_id": 266,
  "room_name": "\u7269\u8054\u7f51\u667a\u6167\u519c\u4e1a\u793a\u8303\u7ad9\u70b9",
  "rps": 0,
  "status": 1,
  "tps": 0,
  "ts": 1,
  "update_time": "2020-11-17 13:53:27",
  "upds": 1
};
export var soil_data = [{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "wind_direction",
    "mac": "868956040789855",
    "number": 225,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "temperature",
    "mac": "868956040789855",
    "number": 9.1,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "pm25",
    "mac": "868956040789855",
    "number": 58,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "pm10",
    "mac": "868956040789855",
    "number": 60,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "illumination",
    "mac": "868956040789855",
    "number": 39739,
    "time": "2020-12-10T13:33:36"
  },
  {
    "address": "1",
    "data_class": "humidity",
    "mac": "868956040789855",
    "number": 25.2,
    "time": "2020-12-10T13:33:36"
  }
]
export var soil = {
  "class_id": 1,
  "config": [{
      "address": 2,
      "depth": 4,
      "sensorNumber": 0
    },
    {
      "address": 1,
      "depth": 20,
      "sensorNumber": 7
    },
    {
      "address": 2,
      "depth": 30,
      "sensorNumber": 0
    },
    {
      "address": 3,
      "depth": 50,
      "sensorNumber": 0
    }
  ],
  "create_time": "2020-08-05 21:01:56",
  "farm_id": 6,
  "id": 31,
  "mac": "868956040789855",
  "name": "\u571f\u58e4\u5892\u60c5\u76d1\u6d4b"
};
export var monitor = [{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  },{
    "address": "1",
    "data_class": "wind_velocity",
    "mac": "868956040789855",
    "number": 2.6,
    "time": "2020-12-10T13:33:36"
  }
]
